import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["dialog"]

  declare readonly dialogTarget: HTMLDialogElement

  open() {
    this.dialogTarget.showModal()
    document.documentElement.style.overflow = "hidden"
  }

  close() {
    this.dialogTarget.close()
  }

  backdropClose(event: MouseEvent) {
    if (event.target === this.dialogTarget) {
      this.dialogTarget.close()
    }
  }

  restoreScroll() {
    document.documentElement.style.overflow = ""
  }
}
